import { render } from "./TDDF18_42.vue?vue&type=template&id=0af28ff5&scoped=true"
import script from "./TDDF18_42.vue?vue&type=script&lang=js"
export * from "./TDDF18_42.vue?vue&type=script&lang=js"

import "./TDDF18_42.vue?vue&type=style&index=0&id=0af28ff5&lang=css"
import "./TDDF18_42.vue?vue&type=style&index=1&id=0af28ff5&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af28ff5"]])

export default __exports__